<template>
    <div>
        <div>
            <el-button type="primary" @click="dialogFormVisible = true">新增</el-button>
        </div>
        <el-radio-group v-model="choose">
            <div
                v-for="(item, index) in showList"
                :key="index"
                @mouseover="curindex = index"
            >
                <el-radio
                    :label="item.id"
                    style="display: block; margin-top: 20px; width: 100%"
                >
                    <span class="addtips">{{item.desc}}</span>
                    <div v-if="item.main" class="first">默认</div>
                    <el-button
                        v-if="curindex === index && !item.main"
                        type="text"
                        icon="el-icon-circle-check"
                        title="设为默认"
                        @click="handleSet(item)"
                        >设为默认</el-button
                    >
                    <el-button
                        v-if="curindex === index"
                        type="text"
                        icon="el-icon-edit"
                        title="修改"
                        @click="handleEdit(item)"
                        >修改</el-button
                    >
                    <el-button
                        v-if="curindex === index"
                        type="text"
                        icon="el-icon-delete"
                        title="删除"
                        @click="handleDelete(item)"
                        >删除</el-button
                    >
                </el-radio>
            </div>
        </el-radio-group>
        <el-pagination
            v-if="totalPage>10"
            style="padding-top:20px"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            background
            layout="prev, pager, next"
            :total="totalPage">
            </el-pagination>
        <el-dialog
            title="新增安装地址"
            :visible.sync="dialogFormVisible"
            append-to-body
            width="60%"
        >
            <add-place ref="add" :cid="cid" @close="addClose" />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveAdd(1)"
                    >保存并继续添加</el-button
                >
                <el-button type="primary" @click="saveAdd(2)"
                    >保存并关闭</el-button
                >
                <el-button type="primary" @click="dialogFormVisible = false">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="修改安装地址"
            :visible.sync="editDialog"
            append-to-body
            width="60%"
        >
            <edit ref="edit" :item="addr" @close="closeEdit" />
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveEdit"
                    >保存并关闭</el-button
                >
                <el-button type="primary" @click="editDialog = false"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import addPlace from "./add";
import Edit from "./Edit";

export default {
    components: {
        addPlace,
        Edit,
    },
    data() {
        return {
            tableData: [],
            showList:[],
            choose: "",
            curindex: "",
            addr: {},
            cid: "",
            dialogFormVisible: false,
            editDialog: false,
            currentPage:1,
            totalPage:10,
        };
    },
    methods: {
        handleCurrentChange(e){
            let key = (e-1)*10;
            this.showList = this.tableData.slice(key,key+10);
        },
        getList(cid, ccid) {
            this.choose = ccid;
            this.cid = cid;
            this.$api.customerWorkAddress({ cid: cid }).then((res) => {
                this.tableData = [];
                this.showList = [];
                this.totalPage = res.data.count;
                res.data.data.forEach((e,index) => {
                    let obj = {
                        id:e.id,
                        main:e.main,
                        district:e.district,
                        address:e.address,
                        desc:e.district.join("")+e.address,
                    }
                    this.tableData.push(obj);
                });
                this.handleCurrentChange(this.currentPage);
            });
        },
        handleSet(item) {
            var param = {
                id: item.id,
                district:item.district.join(','),
                address:item.address,
                main: 1,
            };
            this.$api.editCustomerWorkAddress(param).then((res) => {
                this.$notify({
                    title: "设置默认安装地址",
                    message: "设置成功",
                    type: "success",
                    duration: 1000,
                    onClose: () => {
                        this.choose = item.id;
                        this.getList(this.cid, this.choose);
                    },
                });
            });
        },
        handleDelete(row) {
            const confirmText = ["是否删除所选项？", "注意：删除后不可恢复。"];
            const newData = [];
            const h = this.$createElement;
            for (const i in confirmText) {
                newData.push(h("p", null, confirmText[i]));
            }
            this.$confirm("警告", {
                title: "警告",
                message: h("div", null, newData),
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(
                () => {
                    this.$api.deleteCustomerWorkAddress({ id: row.id })
                        .then((res) => {
                            this.$notify({
                                title: "删除安装地址",
                                message: "删除成功",
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.getList(this.cid, this.choose);
                                },
                            });
                        });
                },
                () => {}
            );
        },
        
        checkPlace() {
            this.tableData.map((item) => {
                if (item.id === this.choose) {
                    this.$emit("close", item);
                }
            });
        },
        handleEdit(row) {
            this.addr = row;
            this.editDialog = true;
            this.$nextTick(() => {
                this.$refs.edit.getInfo();
            });
        },
        saveEdit() {
            this.$nextTick(() => {
                this.$refs.edit.saveEditClose();
            });
        },
        closeEdit() {
            this.editDialog = false;
            this.getList(this.cid, this.choose);
        },
        saveAdd(val) {
            this.$nextTick(() => {
                this.$refs.add.save(val);
            });
        },
        addClose(val) {
            if(val==2){
                this.dialogFormVisible = false;
            }
            this.getList(this.cid, this.choose);
        },
    },
};
</script>

<style scoped>
.first {
    color: #ff973c;
    border: 1px solid rgba(255, 151, 60, 0.4);
    display: inline-block;
    padding: 2px;
    font-size: 12px;
    border-radius: 2px;
    cursor: pointer;
    line-height: 1;
}
.addtips {
    white-space: break-spaces;
}
</style>
